export default {
    RECORDING: "/recording"
}